import { Controller } from "@hotwired/stimulus"

// The untie link stays masked behind a button until it is clicked, for the lifetime of the page -
// there is no toggling back. Both targets are server-rendered; this only flips which is visible.
export default class extends Controller {
  static get targets() { return ["link", "mask"]; }

  reveal() {
    this.linkTarget.classList.remove("hidden");
    this.maskTarget.classList.add("hidden");
  }
}
